import BrandCheck from '@console/components/project/BrandCheck';
import type { AppState } from '@console/reducers';
import {
  getIsApiProject,
  getIsBulkProject,
  getIsGcpProject
} from '@console/selectors/projectDetail/solutionSystem';
import { connect } from 'react-redux';

const mapStateToProps = (state: AppState) => ({
  isApiProject: getIsApiProject(state),
  isBulkProject: getIsBulkProject(state),
  isGcpProject: getIsGcpProject(state)
});

const mapDispatchToProps = () => ({});

export type BrandCheckPropsMappedFromState = ReturnType<typeof mapStateToProps>;
export type BrandCheckPropsMappedFromDispatch = ReturnType<
  typeof mapDispatchToProps
>;

export default connect(mapStateToProps, mapDispatchToProps)(BrandCheck);
